export const Small = 0.84;
export const Large = 1;
